import React, { useState, useEffect, useRef } from 'react';
import HALO from 'vanta/dist/vanta.halo.min'
//import HoverImage from '../hoverImage/HoverImage.js';
//
//import cellsImg from '../../assets/cells.jpg';
//import dotsImg from '../../assets/dots.jpg';
//import netImg from '../../assets/net.jpg';
//import topImg from '../../assets/topology.jpg';
//import trunkImg from '../../assets/trunk.jpg';
//import wavesImg from '../../assets/waves.jpg';

import './Astral.css';

function Astral(props) {

    const [vantaEffect, setVantaEffect] = useState(0)
    const [err, setErr] = useState(false);
    const myRef = useRef(null)
    useEffect(() => {
      try {
          if (!vantaEffect) {
              setVantaEffect(HALO({
                  el: myRef.current,
                  minHeight: 200.00,
                  minWidth: 200.00,
                  baseColor: 0x14171d,
                  backgroundColor: 0xdddfe8,
                  amplitudeFactor: 0.20,
                  xOffset: 0.20,
                  yOffset: -0.02,
                  size: 1.70
              }))
	  }
          return () => {
              if (vantaEffect) vantaEffect.destroy()
          }
      } catch {
          setErr(true);
      }
    }, [vantaEffect])

    return (
        <div className="astral-container">
            <div className="astral-header" onClick={() => props.setMain(true)}>
	        <div className="astral-header-button">GitHub</div>
	        <div className="astral-header-button" onClick={() => props.setMain(false)}>Back to GHOST</div>
	    </div>

	    {err === false ? <div ref={myRef} className="astral-canvas">
	        <div className="astral-background">
	            <div className="astral-background-text">
	                <div className="astral-background-text-astral-reverse">AstralVM</div>
	                <div className="astral-background-text-astral">AstralVM</div>
	                <div className="astral-background-text-citation">
	    		"Any idiot can make money. Keeping money, very few can do."
	                </div>
	                <div className="astral-background-text-name">John McAfee</div>
	            </div>
	        </div>
	    </div> : <div className="astral-canvas-empty">
                 <div className="astral-background">
                     <div className="astral-background-text">
                         <div className="astral-background-text-astral-reverse">AstralVM</div>
                         <div className="astral-background-text-astral">AstralVM</div>
                         <div className="astral-background-text-citation">
                         "Any idiot can make money. Keeping money, very few can do.    "
                         </div>
                         <div className="astral-background-text-name">John McAfee</div>
                     </div>
                 </div>
             </div>
	    }


	    <div className="astral-content">
		<div className="astral-content-technology">
	            <div className="astral-content-main-text">Technology</div>

	    	    {/*
	    	    <div className="astral-content-technology-row">
	                <HoverImage src={dotsImg} black={false} text={"something"} />
	                <HoverImage src={netImg}i black={false} text={"global"} />
	                <HoverImage src={cellsImg} black={false} text={"secret"} />
	            </div>
	    	    <div className="astral-content-technology-row">
	                <HoverImage src={topImg} black={false} text={"something"} />
	                <HoverImage src={trunkImg}i black={false} text={"global"} />
	                <HoverImage src={wavesImg} black={false} text={"secret"} />
	            </div>
		    */}

	        </div>
	    	<div className="astral-content-products">
	            <div className="astral-content-main-text">Products</div>
	        </div>
	    	<div className="astral-content-tokens">
	            <div className="astral-content-main-text">Tokens</div>
	    	</div>
	    	<div className="astral-content-roadmap">
	            <div className="astral-content-main-text">Roadmap</div>
	        </div>
	    </div>

	    <div className="astral-footer">
	        <div className="astral-footer-link">telegram</div>
	        <div className="astral-footer-link">matrix</div>
	        <div className="astral-footer-link">proton</div>
	        <div className="astral-footer-link">xmpp</div>
	    </div>
        </div>
    )
}

export default Astral;
